import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'react-bootstrap';
 
const BookingBasicInfo = ({ booking }) => {
    const [showPaxTable, setShowPaxTable] = useState(false);
  // console.log(booking);
    // Toggle the visibility of the pax details table
    const togglePaxTable = () => {
        setShowPaxTable(prevState => !prevState);
    };
   
    function convertDateFormat(dateStr) {
      const parts = dateStr.split('-'); // Split the string by "-"
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // Rearrange to DD-MM-YYYY
    }

    // function getRandomLightColor() {
    //   const r = Math.floor(200 + Math.random() * 55); // 200–255
    //   const g = Math.floor(200 + Math.random() * 55); // 200–255
    //   const b = Math.floor(200 + Math.random() * 55); // 200–255
    //   return `rgb(${r}, ${g}, ${b})`;
    // }
 
    return (
      <div style={{
        // backgroundColor: getRandomLightColor(),
        borderRadius: '12px',
        padding: '10px',
        margin: '12px',
      }}
      >
        <div className="row">
          <div className="col-md-4 text-black">
            <p>Restaurant: {booking.restaurant_name}</p>
          </div>
          <div className="col-md-4">
            <p>Location: {booking.location}</p>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-4">
            <p>Meal Name: {booking.meal_name}</p>
          </div>
          <div className="col-md-4">
            <p className="card-text">
              Timing : {
                (() => {
                  switch (booking.meal_offered) {
                    case '1':
                      return 'Breakfast';
                    case '2':
                      return 'Snacks';
                    case '3':
                      return 'Lunch';
                    case '4':
                      return 'Dinner';    
                    default:
                      return 'NAN';
                  }
                })()
              }
            </p>
          </div>
          <div className="col-md-4">
            <p>Meal Type: {booking.meal_type ? booking.meal_type : 'NA'}</p>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-6">
            <p>Booking Date: {convertDateFormat(booking.booking_date)}</p>
          </div>
          <div className="col-md-6">
            <p>Trip Name: {booking.trip_name}</p>
          </div>
        </div>
        <hr />
       
        {/* Toggle Button for Pax Details */}
        <div className="row">
         
         
          {/* Conditionally Render the Pax Table */}
          {showPaxTable && (
            <Table
              responsive
              bordered
              style={{
                marginTop: '12px',
            }}
            >
              <thead>
                <tr>
                  <th>Sr no</th>
                  <th>Name</th>
                  <th>Age Group</th>
                  <th>Mail Id</th>
                  <th>Phone No</th>
                </tr>
              </thead>
              <tbody>
                {booking.pax_details.flat().map((pax, index) => (
                  <tr key={pax.id}>
                    <td>{index + 1}</td>
                    <td>{pax.pax_name || 'NA'}</td>
                    <td>{pax.age_group === '1' ? 'Adult' : 'Child'}</td>
                    <td>{pax.email_id || 'NA'}</td>
                    <td>{pax.mobile_no || 'NA'}</td>              
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          <div className="col-md-3">
            <Button onClick={togglePaxTable}>
              {showPaxTable ? 'Hide Pax Details' : 'Show Pax Details'}
            </Button>
          </div>
        </div>
      </div>
    );
};
 
BookingBasicInfo.propTypes = {
    booking: PropTypes.shape({
        mealDate: PropTypes.string,
        meal_offered: PropTypes.string,
        day_name: PropTypes.string,
        meal_amount: PropTypes.string,
        booking_date: PropTypes.string,
        total_meal: PropTypes.string,
        meal_type: PropTypes.string,
        meal_name: PropTypes.string,
        total_amount: PropTypes.string,
        restaurant_name: PropTypes.string,
        location: PropTypes.string,
        trip_name: PropTypes.string,
        pax_details: PropTypes.arrayOf(
            PropTypes.arrayOf( // Updated to reflect nested array structure
                PropTypes.shape({
                    pax_name: PropTypes.string.isRequired,
                    age_group: PropTypes.string.isRequired,
                    mobile_no: PropTypes.string.isRequired,
                    email_id: PropTypes.string.isRequired,
                }),
            ).isRequired,
        ).isRequired,
    }).isRequired,
};
 
export default BookingBasicInfo;
